import { REQUEST_DELETE_LANDING_PAGE, DELETE_LANDING_PAGE_SUCCESS, DELETE_LANDING_PAGE_ERROR } from './actionTypes';

export const requestDeleteLandingPage = () => ({ type: REQUEST_DELETE_LANDING_PAGE });

export const deleteLandingPageSuccess = landingPage => ({ type: DELETE_LANDING_PAGE_SUCCESS, payload: landingPage });

export const deleteLandingPageError = payload => ({ type: DELETE_LANDING_PAGE_ERROR, payload });
